
import { listCupola } from "./listCupola"
import { IComponent } from "./type/dynamic-rendering.interfaces"
//@ts-ignore
import porchSideA from '../asset/svg/porchSides/porchSideA.svg';
//@ts-ignore
import porchSideA_active from '../asset/svg/porchSides/porchSideA_active.svg';
//@ts-ignore
import porchSideB from '../asset/svg/porchSides/porchSideB.svg';
//@ts-ignore
import porchSideB_active from '../asset/svg/porchSides/porchSideB_active.svg';
//@ts-ignore
import porchSideC from '../asset/svg/porchSides/porchSideC.svg';
//@ts-ignore
import porchSideC_active from '../asset/svg/porchSides/porchSideC_active.svg';
//@ts-ignore
import porchSideD from '../asset/svg/porchSides/porchSideD.svg';
//@ts-ignore
import porchSideD_active from '../asset/svg/porchSides/porchSideD_active.svg';
//@ts-ignore
import HintStandart from '../asset/HintStandart.jpg';
//@ts-ignore
import Upscale from '../asset/Upscale.png';
//@ts-ignore
import Classic from '../asset/Classic.png'
// //@ts-ignore
// const porchSideA = require('../asset/svg/porchSides/porchSideA.svg')
// //@ts-ignore
// const porchSideA_active = require('../asset/svg/porchSides/porchSideA_active.svg')
// //@ts-ignore
// const porchSideB = require('../asset/svg/porchSides/porchSideB.svg')
// //@ts-ignore
// const porchSideB_active = require('../asset/svg/porchSides/porchSideB_active.svg')
// //@ts-ignore
// const porchSideC = require('../asset/svg/porchSides/porchSideC.svg')
// //@ts-ignore
// const porchSideC_active = require('../asset/svg/porchSides/porchSideC_active.svg')
// //@ts-ignore
// const porchSideD = require('../asset/svg/porchSides/porchSideD.svg')
// //@ts-ignore
// const porchSideD_active = require('../asset/svg/porchSides/porchSideD_active.svg')
// //@ts-ignore
// const HintStandart = require('../asset/HintStandart.jpg')
// //@ts-ignore
// const Upscale = require('../asset/Upscale.png')
// //@ts-ignore
// const Classic = require('../asset/Classic.png')


let defaultStyle = {

    groupGap: true,
    backgroundColor: '#F4F3F3',
    gap: '12px',
    padding: '6px 19px',
    margin: '0 -16px',

}

export type settingConfigT = {
    key: string
    name: string
    setting: IComponent[]
}

export let settingsCI: Array<IComponent> = [

    {
        type: 'LineParamInput',
        data: {
            id: 'ShipZipCode',
            typeOptions: 'configurationOptions',
            label: 'Destination ZIP code ',
            isRequired: true,
            typeParam: 'LineParamInput',
            additionalProperties: {
                maxWidth: '308px'
            }
        }
    },
    {
        type: 'LineParamRadio',
        data: {
            id: 'PurchaseOpt',
            label: 'Purchase Option',
            isRequired: true,
            typeOptions: 'configurationOptions',
            values: [
                {
                    label: 'Cash',
                    value: 'CA'
                },
                {
                    label: 'Rent To Own',
                    value: 'RO'
                },
                {
                    label: 'Not Sure',
                    value: 'NS'
                },

            ],
            additionalProperties: {
                maxWidth: '308px'
            },
            dependenceParameters: [
                {
                    value: ['CustomerInfo**coDbaZip'],
                },
            ],
        }
    },
    {
        type: 'LineParamRadio',
        data: {
            id: 'Permits',
            label: 'Structure Requires Permits',
            isRequired: true,
            typeOptions: 'configurationOptions',
            values: [
                {
                    label: 'Yes',
                    value: 'Yes'
                },
                {
                    label: 'No',
                    value: 'No'
                },
            ],
            additionalProperties: {
                maxWidth: '308px'
            },
            dependenceParameters: [
                {
                    value: ['CustomerInfo**coDbaZip'],
                },
            ],
        },
    },
    {
        type: 'LineParamSelect',
        data: {
            label: 'Ship via',
            id: 'ShipVia',
            isRequired: true,
            hint: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
            typeOptions: 'configurationOptions',
            values: [
                {
                    label: 'On-site Build',
                    value: 'On_build'
                },
                {
                    label: 'Truck Delivery',
                    value: 'Truck_Delivery'
                },
            ],
            additionalProperties: {
                maxWidth: '308px'
            }
        }
    }
]

export let settingsP: Array<IComponent> = [
    {
        type: 'GroupSetting',
        data: {
            id: 'product__Group1',
            typeOptions: 'groupingOptions',
            embeddedView: [

                {
                    type: 'LineParamSelect',
                    data: {
                        label: 'Siding',
                        id: 'SidingType',
                        typeOptions: 'configurationOptions',
                        isRequired: false,
                        defaultValue: 'Signature',
                        values: [
                            {
                                label: 'LP Smart Panel',
                                value: 'LP Smart Panel'
                            },

                        ],
                        additionalProperties: {
                            maxWidth: '308px',

                        }
                    }
                },
                {
                    type: 'LineParamSelect',
                    data: {
                        label: 'Floor options',
                        id: 'FloorOptions',
                        typeOptions: 'configurationOptions',
                        isRequired: true,
                        values: [
                            {
                                label: 'No floor',
                                value: 'No_floor'
                            },
                            {
                                label: 'Floor',
                                value: 'Floor'
                            },
                        ],
                        additionalProperties: {
                            maxWidth: '308px'
                        }

                    }
                },
                {
                    type: 'LineParamSelect',
                    data: {
                        label: 'Wall Height',
                        id: 'WallHeight',
                        typeOptions: 'configurationOptions',
                        isRequired: false,
                        values: [

                            {
                                label: "4' Wall (58\" stud)",
                                value: '4'
                            },
                            {
                                label: "5' Wall (60\" stud)",
                                value: '5'
                            },
                            {
                                label: "6' Wall (72\" stud)",
                                value: '6'
                            },
                            {
                                label: "7' Wall (84\" stud)",
                                value: '7'
                            },

                            {
                                label: "8' Wall (92.625\" stud)",
                                value: '8'
                            },

                        ],
                        additionalProperties: {
                            maxWidth: '308px',

                        }

                    }
                }
            ]
        }
    }, {
        type: 'GroupSetting',
        data: {
            id: 'Product__WidthLength',
            label: 'Width/length',
            typeOptions: 'groupingOptions',
            embeddedView: [
                {
                    type: 'TwoLineParams',
                    data: {
                        id: "Product__WidthLength__Param",
                        typeOptions: 'groupingOptions',
                        embeddedView: [
                            {
                                type: 'ColumnViewParam',
                                data: {
                                    typeOptions: 'configurationOptions',
                                    label: 'Width',
                                    id: 'WidthSelect',
                                    isRequired: false,

                                    values: [
                                        {
                                            label: '08',
                                            value: '08'
                                        },

                                        {
                                            label: '10',
                                            value: '10'
                                        },

                                        {
                                            label: '12',
                                            value: '12'
                                        },

                                        {
                                            label: '14',
                                            value: '14'
                                        },
                                        {
                                            label: '16',
                                            value: '16'
                                        },

                                    ],
                                    additionalProperties: {
                                        maxWidth: '222px',

                                    }
                                }

                            },
                            {
                                type: 'ColumnViewParam',
                                data: {
                                    typeOptions: 'configurationOptions',
                                    label: 'Length',
                                    id: 'LengthSelect',
                                    isRequired: false,
                                    values: [
                                        {
                                            label: '8',
                                            value: '8'
                                        },
                                        {
                                            label: '10',
                                            value: '10'
                                        },
                                        {
                                            label: '12',
                                            value: '12'
                                        },
                                        {
                                            label: '14',
                                            value: '14'
                                        },
                                        {
                                            label: '16',
                                            value: '16'
                                        },
                                        {
                                            label: '18',
                                            value: '18'
                                        },
                                        {
                                            label: '20',
                                            value: '20'
                                        },
                                        {
                                            label: '22',
                                            value: '22'
                                        },
                                        {
                                            label: '24',
                                            value: '24'
                                        },
                                        {
                                            label: '26',
                                            value: '26'
                                        },
                                        {
                                            label: '28',
                                            value: '28'
                                        },
                                        {
                                            label: '30',
                                            value: '30'
                                        },
                                        {
                                            label: '32',
                                            value: '32'
                                        },
                                        {
                                            label: '34',
                                            value: '34'
                                        },
                                        {
                                            label: '36',
                                            value: '36'
                                        },
                                        {
                                            label: '38',
                                            value: '38'
                                        },

                                    ],
                                    additionalProperties: {
                                        maxWidth: '222px',

                                    }
                                }
                            },
                        ]
                    }
                },
                {
                    type: 'SettingOpening',
                    data: {
                        id: 'Product__WidthLength__FoundationFramingSeries',
                        label: 'Foundation & Framing Series',
                        typeOptions: 'groupingOptionsSwitchingOpening',
                        switchingOptions: false,
                        embeddedView: [
                            {
                                type: 'LineParamSelect',
                                data: {
                                    label: 'Foundation & Framing Series',
                                    id: 'SeriesGroup10',
                                    isRequired: false,
                                    typeOptions: 'configurationOptions',
                                    values: [
                                        {
                                            label: 'Select',
                                            value: 'Select'
                                        },
                                        {
                                            label: 'Signature',
                                            value: 'Signature'
                                        },
                                        {
                                            label: 'Limited',
                                            value: 'Limited'
                                        },
                                    ],
                                    additionalProperties: {
                                        maxWidth: '172px',

                                    }
                                }
                            },
                            {
                                type: 'ListParams',
                                data: {
                                    typeOptions: 'configurationOptions',
                                    id: 'list1',
                                    list: ['- Drip Edge -Included', '- Felt Paper -None', '- Floor Joists -2x4 - 16 in. OC', '- Flooring -5/8 Plywood', '- Skids -4x4', '- Wall Studs -2x4 - 24 in. OC', '- Trusses -2x4 - 24 in. OC']
                                }
                            }
                        ]
                    }
                },
                {
                    type: 'SettingOpening',
                    data: {
                        id: 'Product__WidthLength__SecurityClimateSeries',
                        label: 'Security & Climate Series',
                        typeOptions: 'groupingOptionsSwitchingOpening',
                        switchingOptions: false,
                        embeddedView: [
                            {
                                type: 'LineParamSelect',
                                data: {
                                    label: 'Security & Climate Series',
                                    id: 'SeriesGroup20',
                                    isRequired: false,
                                    typeOptions: 'configurationOptions',
                                    values: [
                                        {
                                            label: 'Select',
                                            value: 'Select'
                                        },
                                        {
                                            label: 'Signature',
                                            value: 'Signature'
                                        },
                                        {
                                            label: 'Limited',
                                            value: 'Limited'
                                        },
                                    ],
                                    additionalProperties: {
                                        maxWidth: '172px',

                                    }
                                }
                            },
                            {
                                type: 'ListParams',
                                data: {
                                    id: 'list2',
                                    typeOptions: 'configurationOptions',
                                    list: ['- Shed Door Bolts -6" Barrel Bolt', '- Shed Door Handle -Ulrich HD Latch and Key', '- Shed Door Hinge -12" Decorative Security Hinge w/ carriage bolt', '- Residential Door Hardware -Standard Kwikset Hardware', '- Shed Door Thresholds -Diamond Plate', '- Eave Vent -Continuous', '- Hurricane Ties -None', '- Ridge Vent -Continuous', '- Roof Radiant Barrier -Included', '- Wall Vents -None']
                                }
                            }
                        ]
                    }
                },
                {
                    type: 'SettingOpening',
                    data: {
                        id: 'Product__WidthLength__TrimSeries',
                        label: 'Trim Series',
                        typeOptions: 'groupingOptionsSwitchingOpening',
                        switchingOptions: false,
                        embeddedView: [
                            {
                                type: 'LineParamSelect',
                                data: {
                                    label: 'Trim Series',
                                    id: 'SeriesGroup30',
                                    isRequired: false,
                                    typeOptions: 'configurationOptions',
                                    values: [
                                        {
                                            label: 'Select',
                                            value: 'Select'
                                        },
                                        {
                                            label: 'Signature',
                                            value: 'Signature'
                                        },
                                        {
                                            label: 'Limited',
                                            value: 'Limited'
                                        },
                                    ],
                                    additionalProperties: {
                                        maxWidth: '172px',

                                    }
                                }
                            },
                            {
                                type: 'ListParams',
                                data: {
                                    id: 'list1',
                                    typeOptions: 'configurationOptions',
                                    list: ['- Caulking -None', '- Corner Trim -1x2', '- Fascia -1x4', '- Overhangs -4 in.', '- Roof Pitch -21/12 - 4.5/12']
                                }
                            }
                        ]
                    }
                },
            ]
        }
    }
]
export let settingsBaseOption: Array<IComponent> = [
    {
        type: 'GroupSetting',
        data: {
            id: 'BaseOption__PorchOptions',
            label: 'Porch Options',
            typeOptions: 'groupingOptions',
            embeddedView: [
                {
                    type: 'SwitchStandardST',
                    data: {
                        label: 'Add Porch',
                        id: 'UPG_ElecLigPorchPkg',
                        typeOptions: 'configurationOptions',
                    }
                },
                {
                    type: 'GroupSettingBase',
                    data: {
                        dependencySettings: [
                            {
                                dependencyType: 'isVisible',
                                idParams: 'UPG_ElecLigPorchPkg',
                                isValue: true
                            }

                        ],
                        isVisible: false,
                        id: 'BaseOption__Group_1',
                        typeOptions: 'groupingOptions',
                        embeddedView: [
                            {
                                type: 'PorchSidesST',
                                data: {
                                    text: 'Choose the side on which the porch will be located. Resize the selected porch using the cursor',
                                    typeOptions: 'configurationOptions',
                                    id: 'BaseOption__PorchSides',
                                    values: [
                                        {
                                            name: 'Side A',
                                            id: 'porchSideA',
                                            icon: porchSideA,
                                            iconActive: porchSideA_active,
                                        },
                                        {
                                            name: 'Side B',
                                            id: 'porchSideB',
                                            icon: porchSideB,
                                            iconActive: porchSideB_active,
                                        },
                                        {
                                            name: 'Side C',

                                            id: 'porchSideC',
                                            icon: porchSideC,
                                            iconActive: porchSideC_active,
                                        },
                                        {
                                            name: 'Side D',
                                            id: 'porchSideD',
                                            icon: porchSideD,
                                            iconActive: porchSideD_active,
                                        }
                                    ]
                                }
                            },
                            {
                                type: 'LineParamGT',
                                data: {
                                    label: 'Porch Decking Color ',
                                    id: 'BaseOption__LineParams',
                                    typeOptions: 'groupingOptions',
                                    isRequired: false,
                                    embeddedView: [
                                        {
                                            type: 'PorchSidesColorST',
                                            data: {
                                                id: 'BaseOption__PorchDeckingColor',
                                                typeOptions: 'configurationOptions',
                                                values: [
                                                    {
                                                        id: 'PorchDeckingColorBrown',
                                                        colors: '#A6886C',
                                                        name: 'Brown',
                                                    },
                                                    {
                                                        id: 'PorchDeckingColorGray',
                                                        name: 'Gray',
                                                        colors: '#C4C4C4',
                                                    },
                                                ]
                                            }
                                        },
                                    ]
                                }
                            },

                        ]
                    }
                },
            ]
        }
    },

    {
        type: 'GroupSetting',
        data: {
            id: 'LoftOptions',
            label: 'Loft Options',
            typeOptions: 'groupingOptions',
            embeddedView: [
                {
                    type: 'SwitchStandardST',
                    data: {
                        label: 'Add Loft',
                        id: 'BaseOption_AddLoft',
                        typeOptions: 'configurationOptions',
                    }
                },
                {
                    type: 'GroupSettingBase',
                    data: {
                        dependencySettings: [
                            {
                                dependencyType: 'isVisible',
                                idParams: 'BaseOption_AddLoft',
                                isValue: true
                            }

                        ],
                        isVisible: false,
                        id: 'BaseOption__Group_2',
                        typeOptions: 'groupingOptions',
                        embeddedView: [
                            {
                                type: 'PorchSidesST',
                                data: {
                                    text: 'Choose the side on which the loft will be located. Resize the selected porch using the cursor',
                                    typeOptions: 'configurationOptions',
                                    id: 'BaseOption__PorchLoft',
                                    values: [
                                        {
                                            name: 'Side A',
                                            id: 'porchSideA',
                                            icon: porchSideA,
                                            iconActive: porchSideA_active,
                                        },
                                        {
                                            name: 'Side B',
                                            id: 'porchSideB',
                                            icon: porchSideB,
                                            iconActive: porchSideB_active,
                                        },
                                        {
                                            name: 'Side C',

                                            id: 'porchSideC',
                                            icon: porchSideC,
                                            iconActive: porchSideC_active,
                                        },
                                        {
                                            name: 'Side D',
                                            id: 'porchSideD',
                                            icon: porchSideD,
                                            iconActive: porchSideD_active,
                                        }
                                    ]
                                }
                            },


                        ]
                    }
                },
            ]
        }
    },
]

export let settingsS: Array<IComponent> = [
    {
        type: 'GroupSetting',
        data: {
            id: 'BaseOption__PorchOptions',
            typeOptions: 'groupingOptions',
            embeddedView: [
                {
                    type: 'TwoLineParams',
                    data: {
                        id: "Product__WidthLength__Param",
                        typeOptions: 'groupingOptions',
                        embeddedView: [
                            {
                                type: 'SwitchStandardST',
                                data: {
                                    label: 'Add Shutters',
                                    id: 'ShuttersOpt',
                                    typeOptions: 'configurationOptions',
                                }
                            },
                            {
                                type: 'SwitchStandardST',
                                data: {
                                    label: 'Add Flower Boxes',
                                    id: 'FlowerBoxesOpt',
                                    typeOptions: 'configurationOptions',
                                }
                            },

                        ]
                    }
                },
                {
                    type: 'GroupSettingBase',
                    data: {
                        id: "Product__WidthLength__Param1111",
                        typeOptions: 'groupingOptions',
                        isVisible: true,
                        embeddedView: [
                            {
                                type: 'SwitchStandardST',
                                data: {
                                    label: 'Add 1x4 White Window Trim',
                                    id: 'WIN1X4TRIMWHITEOPT',
                                    typeOptions: 'configurationOptions',
                                }
                            },

                        ]
                    }
                },
                {
                    type: 'OrientationSidesST',
                    data: {
                        id: 'orientationSide',
                        typeOptions: 'configurationOptions',
                        values: [
                            {
                                id: 'SideA',
                                label: 'Side A',
                            },
                            {
                                id: 'SideB',
                                label: 'Side B',
                            },
                            {
                                id: 'SideC',
                                label: 'Side C',
                            },
                            {
                                id: 'SideD',
                                label: 'Side D',
                            },
                        ]
                    }
                },
                {
                    type: 'SideCheckViewSettingST',
                    data: {
                        id: 'orientationSideView',
                        typeOptions: 'configurationOptions',
                        values: [

                        ]
                    }
                },
                {
                    type: 'OptionsSideGroup',
                    data: {
                        dependencySettings: [
                            {
                                dependencyType: 'isVisible',
                                idParams: 'orientationSide',
                                isValue: 'SideA'
                            }
                        ],
                        id: 'OptionsSideGroup_SideA',
                        typeOptions: 'configurationOptions',
                        embeddedView: []
                    }
                },
                {
                    type: 'OptionsSideGroup',
                    data: {
                        dependencySettings: [
                            {
                                dependencyType: 'isVisible',
                                idParams: 'orientationSide',
                                isValue: 'SideB'
                            }
                        ],
                        id: 'OptionsSideGroup_SideB',
                        typeOptions: 'configurationOptions',
                        embeddedView: []
                    }
                },
                {
                    type: 'OptionsSideGroup',
                    data: {
                        dependencySettings: [
                            {
                                dependencyType: 'isVisible',
                                idParams: 'orientationSide',
                                isValue: 'SideC'
                            }
                        ],
                        id: 'OptionsSideGroup_SideC',
                        typeOptions: 'configurationOptions',
                        embeddedView: []
                    }
                },
                {
                    type: 'OptionsSideGroup',
                    data: {
                        dependencySettings: [
                            {
                                dependencyType: 'isVisible',
                                idParams: 'orientationSide',
                                isValue: 'SideD'
                            }
                        ],
                        id: 'OptionsSideGroup_SideD',
                        typeOptions: 'configurationOptions',
                        embeddedView: []
                    }
                }
            ]
        }
    }
]
export let settingsU: Array<IComponent> = [
    {
        type: 'GroupSetting',
        data: {
            id: 'BaseOption__PorchOptions',
            typeOptions: 'groupingOptions',
            embeddedView: [

                {
                    type: 'SettingOpening',
                    data: {
                        label: 'Floor Upgrades',
                        id: 'OptionsSideGroup_SideB1',
                        typeOptions: 'configurationOptions',
                        embeddedView: [
                            {
                                type: 'SwitchStandardST',
                                data: {
                                    label: 'R10 Floor Insulation',
                                    id: 'UPG_FloorIns',
                                    typeOptions: 'configurationOptions',
                                }
                            },
                        ]
                    }
                },
                {
                    type: 'SettingOpening',
                    data: {
                        label: 'Structure Upgrades',
                        id: 'OptionsSideGroup_SideB2',
                        typeOptions: 'configurationOptions',
                        additionalProperties: {
                            groupGap: true,
                        },
                        embeddedView: [
                            {
                                type: 'GroupCupolaST',
                                data: {
                                    id: 'GroupCupolaSTСupola',
                                    typeOptions: 'configurationOptions',
                                    values: listCupola
                                }
                            },
                            {
                                type: 'SwitchStandardST',
                                data: {
                                    label: 'House Wrap',
                                    id: 'UPG_HouseWrap',
                                    typeOptions: 'configurationOptions',
                                }
                            },
                            {
                                type: 'SwitchStandardST',
                                data: {
                                    label: 'Reverse Gable (pitch and width = Gable)',
                                    id: 'UPG_ReverseGable',
                                    typeOptions: 'configurationOptions',
                                }
                            },
                            {
                                type: 'GroupSettingBase',
                                data: {
                                    dependencySettings: [
                                        {
                                            dependencyType: 'isVisible',
                                            idParams: 'UPG_ReverseGable',
                                            isValue: true
                                        }
                                    ],
                                    isVisible: false,
                                    id: 'UPG_ReverseGable#Group',
                                    typeOptions: 'groupingOptions',
                                    additionalProperties: defaultStyle,
                                    embeddedView: [
                                        {
                                            type: 'LineParamSelect',
                                            data: {
                                                label: 'Quantity',
                                                id: 'UPG_ReverseGableQuan',
                                                typeOptions: 'configurationOptions',
                                                values: [
                                                    { label: "1", value: '1' },
                                                    { label: "2", value: '2' },
                                                    { label: "3", value: '3' },
                                                    { label: "4", value: '4' },
                                                    { label: "5", value: '5' },
                                                ],
                                                additionalProperties: {
                                                    maxWidth: '252px',
                                                    margin: '0'
                                                }
                                            },
                                        },

                                    ]
                                }
                            },
                            {
                                type: 'SwitchStandardST',
                                data: {
                                    label: 'Reverse Gable Window',
                                    id: 'UPG_ReverseGableWindow',
                                    typeOptions: 'configurationOptions',
                                }
                            },
                            {
                                type: 'GroupSettingBase',
                                data: {
                                    dependencySettings: [
                                        {
                                            dependencyType: 'isVisible',
                                            idParams: 'UPG_ReverseGableWindow',
                                            isValue: true
                                        }
                                    ],
                                    isVisible: false,
                                    id: 'UPG_ReverseGableWindow#Group',
                                    typeOptions: 'groupingOptions',
                                    additionalProperties: defaultStyle,
                                    embeddedView: [
                                        {
                                            type: 'LineParamSelect',
                                            data: {
                                                label: 'Quantity',
                                                id: 'UPG_ReverseGableWindowQuan',
                                                typeOptions: 'configurationOptions',
                                                values: [
                                                    { label: "1", value: '1' },
                                                    { label: "2", value: '2' },
                                                    { label: "3", value: '3' },
                                                    { label: "4", value: '4' },
                                                    { label: "5", value: '5' },
                                                ],
                                                additionalProperties: {
                                                    maxWidth: '252px',
                                                    margin: '0'
                                                }
                                            },
                                        },

                                    ]
                                }
                            },
                            {
                                type: 'SwitchStandardST',
                                data: {
                                    label: 'Gable Dormer (3 ft)',
                                    id: 'UPG_GableDormer',
                                    typeOptions: 'configurationOptions',
                                }
                            },
                            {
                                type: 'GroupSettingBase',
                                data: {
                                    dependencySettings: [
                                        {
                                            dependencyType: 'isVisible',
                                            idParams: 'UPG_GableDormer',
                                            isValue: true
                                        }
                                    ],
                                    isVisible: false,
                                    id: 'UPG_GableDormer#Group',
                                    typeOptions: 'groupingOptions',
                                    additionalProperties: defaultStyle,
                                    embeddedView: [
                                        {
                                            type: 'LineParamSelect',
                                            data: {
                                                label: 'Quantity',
                                                id: 'UPG_GableDormerQuan',
                                                typeOptions: 'configurationOptions',
                                                values: [
                                                    { label: "1", value: '1' },
                                                    { label: "2", value: '2' },
                                                    { label: "3", value: '3' },
                                                    { label: "4", value: '4' },
                                                    { label: "5", value: '5' },
                                                ],
                                                additionalProperties: {
                                                    maxWidth: '252px',
                                                    margin: '0'
                                                }
                                            },
                                        },

                                    ]
                                }
                            },
                            {
                                type: 'SwitchStandardST',
                                data: {
                                    label: 'Craftsman Corbels (on gable ends)',
                                    id: 'UPG_Corbels',
                                    typeOptions: 'configurationOptions',
                                }
                            },


                        ]
                    }
                },
                {
                    type: 'SettingOpening',
                    data: {
                        label: 'Interior Options',
                        id: 'OptionsSideGroup_SideB1233',
                        typeOptions: 'configurationOptions',
                        additionalProperties: {
                            groupGap: true,
                        },
                        embeddedView: [
                            {
                                type: 'HintWrapGroupGT',
                                data: {
                                    id: 'hintInteriorOptions1',
                                    typeOptions: 'groupingOptions',
                                    hint: {
                                        img: HintStandart,
                                        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna',
                                        // moreLink: "#",
                                        // moreText: "More...",
                                        alt: "string",
                                    },
                                    embeddedView: [
                                        {
                                            type: 'SwitchStandardST',
                                            data: {
                                                label: 'OSB Double Shelving per ft. (16" depth)',
                                                id: 'UPG_ShelfDbl16',
                                                typeOptions: 'configurationOptions',
                                            }
                                        },
                                    ]
                                }
                            },
                            {
                                type: 'GroupSettingBase',
                                data: {
                                    dependencySettings: [
                                        {
                                            dependencyType: 'isVisible',
                                            idParams: 'UPG_ShelfDbl16',
                                            isValue: true
                                        }
                                    ],
                                    isVisible: false,
                                    id: 'UPG_ShelfDbl16#Group',
                                    typeOptions: 'groupingOptions',
                                    additionalProperties: defaultStyle,
                                    embeddedView: [
                                        {
                                            type: 'LineParamSelect',
                                            data: {
                                                label: 'Quantity',
                                                id: 'UPG_ShelfDbl16Quan',
                                                typeOptions: 'configurationOptions',
                                                values: [
                                                    { label: "1", value: '1' },
                                                    { label: "2", value: '2' },
                                                    { label: "3", value: '3' },
                                                    { label: "4", value: '4' },
                                                    { label: "5", value: '5' },
                                                ],
                                                additionalProperties: {
                                                    maxWidth: '252px',
                                                    margin: '0'
                                                }
                                            },
                                        },

                                    ]
                                }
                            },
                            {
                                type: 'HintWrapGroupGT',
                                data: {
                                    id: 'hintInteriorOptions1',
                                    typeOptions: 'groupingOptions',
                                    hint: {
                                        img: HintStandart,
                                        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna',
                                        // moreLink: "#",
                                        // moreText: "More...",
                                        alt: "string",
                                    },
                                    embeddedView: [
                                        {
                                            type: 'SwitchStandardST',
                                            data: {
                                                label: 'Plywood Work Bench per ft. (24" depth)',
                                                id: 'UPG_WorkBench24',
                                                typeOptions: 'configurationOptions',
                                            }
                                        },
                                    ]
                                }
                            },
                            {
                                type: 'GroupSettingBase',
                                data: {
                                    dependencySettings: [
                                        {
                                            dependencyType: 'isVisible',
                                            idParams: 'UPG_WorkBench24',
                                            isValue: true
                                        }
                                    ],
                                    isVisible: false,
                                    id: 'UPG_WorkBench24#Group',
                                    typeOptions: 'groupingOptions',
                                    additionalProperties: defaultStyle,
                                    embeddedView: [
                                        {
                                            type: 'LineParamSelect',
                                            data: {
                                                label: 'Quantity',
                                                id: 'UPG_WorkBench24Quan',
                                                typeOptions: 'configurationOptions',
                                                values: [
                                                    { label: "1", value: '1' },
                                                    { label: "2", value: '2' },
                                                    { label: "3", value: '3' },
                                                    { label: "4", value: '4' },
                                                    { label: "5", value: '5' },
                                                ],
                                                additionalProperties: {
                                                    maxWidth: '252px',
                                                    margin: '0'
                                                }
                                            },
                                        },

                                    ]
                                }
                            },

                            {
                                type: 'HintWrapGroupGT',
                                data: {
                                    id: 'hintInteriorOptions1',
                                    typeOptions: 'groupingOptions',
                                    hint: {
                                        img: HintStandart,
                                        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna',
                                        // moreLink: "#",
                                        // moreText: "More...",
                                        alt: "string",
                                    },
                                    embeddedView: [
                                        {
                                            type: 'SwitchStandardST',
                                            data: {
                                                label: 'HD 2" Solid Wood Work Bench per ft. (24" depth)',
                                                id: 'UPG_WorkBench24HD',
                                                typeOptions: 'configurationOptions',
                                            }
                                        },
                                    ]
                                }
                            },
                            {
                                type: 'GroupSettingBase',
                                data: {
                                    dependencySettings: [
                                        {
                                            dependencyType: 'isVisible',
                                            idParams: 'UPG_WorkBench24HD',
                                            isValue: true
                                        }
                                    ],
                                    isVisible: false,
                                    id: 'UPG_WorkBench24HD#Group',
                                    typeOptions: 'groupingOptions',
                                    additionalProperties: defaultStyle,
                                    embeddedView: [
                                        {
                                            type: 'LineParamSelect',
                                            data: {
                                                label: 'Quantity',
                                                id: 'UPG_WorkBench24HDQuan',
                                                typeOptions: 'configurationOptions',
                                                values: [
                                                    { label: "1", value: '1' },
                                                    { label: "2", value: '2' },
                                                    { label: "3", value: '3' },
                                                    { label: "4", value: '4' },
                                                    { label: "5", value: '5' },
                                                ],
                                                additionalProperties: {
                                                    maxWidth: '252px',
                                                    margin: '0'
                                                }
                                            },
                                        },

                                    ]
                                }
                            },

                            {
                                type: 'HintWrapGroupGT',
                                data: {
                                    id: 'hintInteriorOptions1',
                                    typeOptions: 'groupingOptions',
                                    hint: {
                                        img: HintStandart,
                                        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna',
                                        // moreLink: "#",
                                        // moreText: "More...",
                                        alt: "string",
                                    },
                                    embeddedView: [
                                        {
                                            type: 'SwitchStandardST',
                                            data: {
                                                label: '8 ft. Pegboard Section',
                                                id: 'UPG_PegBoard',
                                                typeOptions: 'configurationOptions',
                                            }
                                        },
                                    ]
                                }
                            },
                            {
                                type: 'GroupSettingBase',
                                data: {
                                    dependencySettings: [
                                        {
                                            dependencyType: 'isVisible',
                                            idParams: 'UPG_PegBoard',
                                            isValue: true
                                        }
                                    ],
                                    isVisible: false,
                                    id: 'UPG_PegBoard#Group',
                                    typeOptions: 'groupingOptions',
                                    additionalProperties: defaultStyle,
                                    embeddedView: [
                                        {
                                            type: 'LineParamSelect',
                                            data: {
                                                label: 'Quantity',
                                                id: 'UPG_PegboardQuan',
                                                typeOptions: 'configurationOptions',
                                                values: [
                                                    { label: "1", value: '1' },
                                                    { label: "2", value: '2' },
                                                    { label: "3", value: '3' },
                                                    { label: "4", value: '4' },
                                                    { label: "5", value: '5' },
                                                ],
                                                additionalProperties: {
                                                    maxWidth: '252px',
                                                    margin: '0'
                                                }
                                            },
                                        },

                                    ]
                                }
                            },
                            {
                                type: 'HintWrapGroupGT',
                                data: {
                                    id: 'hintInteriorOptions1',
                                    typeOptions: 'groupingOptions',
                                    hint: {
                                        img: HintStandart,
                                        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna',
                                        // moreLink: "#",
                                        // moreText: "More...",
                                        alt: "string",
                                    },
                                    embeddedView: [


                                        {
                                            type: 'SwitchStandardST',
                                            data: {
                                                label: 'Interior Finish Package',
                                                id: 'UPG_IntFinish',
                                                typeOptions: 'configurationOptions',
                                            }
                                        },

                                    ]
                                }
                            },

                            {
                                type: 'GroupSettingBase',
                                data: {
                                    dependencySettings: [
                                        {
                                            dependencyType: 'isVisible',
                                            idParams: 'UPG_IntFinish',
                                            isValue: true
                                        }

                                    ],
                                    isVisible: false,
                                    id: 'BaseOption__Group_1',
                                    typeOptions: 'groupingOptions',
                                    additionalProperties: {
                                        groupGap: true,
                                        backgroundColor: '#F4F3F3',
                                        gap: '12px',
                                        padding: '6px 19px',
                                        margin: '0 -16px',
                                    },
                                    embeddedView: [
                                        {
                                            type: 'LineParamSelect',
                                            data: {
                                                label: 'Wall finish Material',
                                                id: 'IntFinP_WallFinMatl',
                                                typeOptions: 'configurationOptions',
                                                values: [
                                                    {
                                                        label: "test data",
                                                        value: 'test data'
                                                    },
                                                ],
                                                additionalProperties: {
                                                    maxWidth: '252PX',
                                                    margin: '0'
                                                }
                                            },
                                        },
                                        {
                                            type: 'LineParamSelect',
                                            data: {
                                                label: 'Celling finish Meterial',
                                                id: 'IntFinP_CeilFinMatl',
                                                typeOptions: 'configurationOptions',
                                                isRequired: false,
                                                values: [
                                                    {
                                                        label: "test data",
                                                        value: 'test data'
                                                    },
                                                ],
                                                additionalProperties: {
                                                    maxWidth: '252PX',
                                                    margin: '0'
                                                }
                                            },
                                        },
                                        {
                                            type: 'LineParamSelect',
                                            data: {
                                                label: 'Wall Finish Type',
                                                id: 'IntFinP_WallFinType',
                                                typeOptions: 'configurationOptions',

                                                values: [
                                                    {
                                                        label: "White",
                                                        value: 'White'
                                                    },
                                                    {
                                                        label: "Gray",
                                                        value: 'Gray'
                                                    },
                                                ],
                                                additionalProperties: {
                                                    maxWidth: '252PX',
                                                    margin: '0'
                                                }
                                            },
                                        },
                                        {
                                            type: 'LineParamRadio',
                                            data: {
                                                label: 'Premium Wash Color of Wall Finish Type',
                                                id: 'IntFinWash_WallColor',
                                                typeOptions: 'configurationOptions',

                                                values: [
                                                    {
                                                        label: "White",
                                                        value: 'White'
                                                    },
                                                    {
                                                        label: "Gray",
                                                        value: 'Gray'
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            type: 'LineParamSelect',
                                            data: {
                                                label: 'Celling finish Type',
                                                id: 'IntFinFinishTypeWallCeilingMix',
                                                typeOptions: 'configurationOptions',
                                                isRequired: false,
                                                values: [
                                                    {
                                                        label: "4' Wall (58\" stud)",
                                                        value: '4'
                                                    },
                                                ],
                                                additionalProperties: {
                                                    maxWidth: '252PX',
                                                    margin: '0'
                                                }
                                            },
                                        },

                                        {
                                            type: 'LineParamSelect',
                                            data: {
                                                label: 'Sherwin Williams Color Number',
                                                id: 'IntFinPaint_WallCustomColor',
                                                typeOptions: 'configurationOptions',

                                                values: [
                                                    {
                                                        label: "11",
                                                        value: '11'
                                                    },
                                                    {
                                                        label: "42",
                                                        value: '42'
                                                    },
                                                ],
                                                additionalProperties: {
                                                    maxWidth: '252PX',
                                                    margin: '0'
                                                }
                                            },
                                        },
                                        {
                                            type: 'SwitchStandardST',
                                            data: {
                                                label: 'Trim finish type (dif from base)',
                                                id: 'Trim finish type (dif from base)',
                                                typeOptions: 'configurationOptions',
                                            }
                                        },
                                        {
                                            type: 'LineParamSelect',
                                            data: {
                                                label: 'Laminate flooring color',
                                                id: 'Laminate flooring color',
                                                typeOptions: 'configurationOptions',
                                                isRequired: false,
                                                values: [
                                                    {
                                                        label: "4' Wall (58\" stud)",
                                                        value: '4'
                                                    },
                                                ],
                                                additionalProperties: {
                                                    maxWidth: '252PX',
                                                    margin: '0'
                                                }
                                            },
                                        },
                                        {
                                            type: 'LineParamSelect',
                                            data: {
                                                label: 'HVAC Type',
                                                id: 'IntFinP_HVACType',
                                                typeOptions: 'configurationOptions',
                                                isRequired: false,
                                                values: [
                                                    {
                                                        label: "4' Wall (58\" stud)",
                                                        value: '4'
                                                    },
                                                ],
                                                additionalProperties: {
                                                    maxWidth: '252PX',
                                                    margin: '0'
                                                }
                                            },
                                        },
                                        {
                                            type: 'SwitchStandardST',
                                            data: {
                                                label: 'Add Storage/Finished Area Partition Wall',
                                                id: 'IntFinPartitionWall',
                                                typeOptions: 'configurationOptions',
                                            },
                                        },
                                        {
                                            type: 'LineParamInput',
                                            data: {
                                                label: 'Distance in FT from Side A',
                                                id: 'IntFinPartitionWall_DistFromA',
                                                typeOptions: 'configurationOptions',

                                                additionalProperties: {
                                                    maxWidth: '252PX',
                                                    margin: '0'
                                                }
                                            },
                                        },
                                        {
                                            type: 'LineParamRadio',
                                            data: {
                                                label: 'Storage Side',
                                                id: 'IntFinPartitionWall_StorageSide',
                                                typeOptions: 'configurationOptions',
                                                values: [
                                                    {
                                                        label: "A",
                                                        value: 'A'
                                                    },
                                                    {
                                                        label: "C",
                                                        value: 'C'
                                                    },

                                                ],
                                            },
                                        },

                                        // {
                                        //     type: 'LineParamSelect',
                                        //     data: {
                                        //         label: 'Trim Finish Type',
                                        //         id: 'IntFinFinishTypeTrimBaseMix',
                                        //         typeOptions: 'configurationOptions',

                                        //         values: [
                                        //             {
                                        //                 label: "11",
                                        //                 value: '11'
                                        //             },
                                        //             {
                                        //                 label: "42",
                                        //                 value: '42'
                                        //             },
                                        //         ],
                                        //         additionalProperties: {
                                        //             maxWidth: '252PX',
                                        //             margin: '0'
                                        //         }
                                        //     },
                                        // },


                                        // {
                                        //     type: 'LineParamSelect',
                                        //     data: {
                                        //         label: 'Premium Wash Color of Trim Finish Type',
                                        //         id: 'IntFinWash_TrimColor',
                                        //         typeOptions: 'configurationOptions',

                                        //         values: [
                                        //             {
                                        //                 label: "Premium Wash",
                                        //                 value: 'Premium Wash'
                                        //             },

                                        //         ],
                                        //     },
                                        // },
                                        // {
                                        //     type: 'LineParamSelect',
                                        //     data: {
                                        //         label: 'Sherwin Williams Color Number of Trim Finish Type ',
                                        //         id: 'IntFinPaint_TrimCustomColor',
                                        //         typeOptions: 'configurationOptions',

                                        //         values: [
                                        //             {
                                        //                 label: "11",
                                        //                 value: '11'
                                        //             },
                                        //             {
                                        //                 label: "42",
                                        //                 value: '42'
                                        //             },

                                        //         ],
                                        //     },
                                        // },

                                        {
                                            type: 'SwitchStandardST',
                                            data: {
                                                label: 'Loft Finish Over Finished Area',
                                                id: 'IntFinLoftAboveFinish',
                                                typeOptions: 'configurationOptions',
                                            },
                                        },
                                        {
                                            type: 'SwitchStandardST',
                                            data: {
                                                label: 'Loft Finish Over Storage Area',
                                                id: 'IntFinLoftAboveStorage',
                                                typeOptions: 'configurationOptions',
                                            },
                                        },


                                        // {
                                        //     type: 'LineParamInput',
                                        //     data: {
                                        //         label: 'Sherwin Williams Color Number',
                                        //         id: 'Wall finish Material',
                                        //         typeOptions: 'configurationOptions',

                                        //         additionalProperties: {
                                        //             maxWidth: '252PX',
                                        //             margin: '0'
                                        //         }
                                        //     },
                                        // },





                                    ]
                                }
                            },
                            {
                                type: 'HintWrapGroupGT',
                                data: {
                                    id: 'hintInteriorOptions1',
                                    typeOptions: 'groupingOptions',
                                    hint: {
                                        img: HintStandart,
                                        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna',
                                        // moreLink: "#",
                                        // moreText: "More...",
                                        alt: "string",
                                    },
                                    embeddedView: [


                                        {
                                            type: 'SwitchStandardST',
                                            data: {
                                                label: 'Finish Ready Framing Package',
                                                id: 'IntFinFinishReadyFramingPkg',
                                                typeOptions: 'configurationOptions',
                                            }
                                        },
                                    ]
                                }
                            },

                            {
                                type: 'HintWrapGroupGT',
                                data: {
                                    id: 'hintInteriorOptions1',
                                    typeOptions: 'groupingOptions',
                                    hint: {
                                        img: HintStandart,
                                        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna',
                                        // moreLink: "#",
                                        // moreText: "More...",
                                        alt: "string",
                                    },
                                    embeddedView: [
                                        {
                                            type: 'SwitchStandardST',
                                            data: {
                                                label: 'Single Circuit Electrical Package ',
                                                id: 'UPG_ElecPkgSC',
                                                typeOptions: 'configurationOptions',
                                            }
                                        },
                                    ]
                                }
                            },





                            {
                                type: 'GroupSettingBase',
                                data: {
                                    dependencySettings: [
                                        {
                                            dependencyType: 'isVisible',
                                            idParams: 'UPG_ElecPkgSC',
                                            isValue: true
                                        }

                                    ],
                                    isVisible: false,
                                    id: 'UPG_ElecPkgSC#grouup',
                                    typeOptions: 'groupingOptions',
                                    additionalProperties: {
                                        groupGap: true,
                                        backgroundColor: '#F4F3F3',
                                        gap: '12px',
                                        padding: '6px 19px',
                                        margin: '0 -16px',
                                    },
                                    embeddedView: [
                                        {
                                            type: 'SwitchStandardST',
                                            data: {
                                                label: 'Extension cord hookup to outside w/ weatherproof box',
                                                id: 'UPG_ElecExtPigtail',
                                                typeOptions: 'configurationOptions',
                                            }
                                        },
                                    ]
                                }
                            },


                            {
                                type: 'HintWrapGroupGT',
                                data: {
                                    id: 'hintInteriorOptions1',
                                    typeOptions: 'groupingOptions',
                                    hint: {
                                        img: HintStandart,
                                        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna',
                                        // moreLink: "#",
                                        // moreText: "More...",
                                        alt: "string",
                                    },
                                    embeddedView: [
                                        {
                                            type: 'SwitchStandardST',
                                            data: {
                                                label: 'Basic Electrical Package',
                                                id: 'UPG_ElecPkg',
                                                typeOptions: 'configurationOptions',
                                            }
                                        },
                                    ]
                                }
                            },

                            {
                                type: 'GroupSettingBase',
                                data: {
                                    dependencySettings: [
                                        {
                                            dependencyType: 'isVisible',
                                            idParams: 'UPG_ElecPkg',
                                            isValue: true
                                        }

                                    ],
                                    isVisible: false,
                                    id: 'BaseOption__Group_1',
                                    typeOptions: 'groupingOptions',
                                    additionalProperties: {
                                        groupGap: true,
                                        backgroundColor: '#F4F3F3',
                                        gap: '12px',
                                        padding: '6px 19px',
                                        margin: '0 -16px',
                                    },
                                    embeddedView: [
                                        {
                                            type: 'SwitchStandardST',
                                            data: {
                                                label: 'Add 110v 30 amp Outlet',
                                                id: 'UPG_ElecOut110v30a',
                                                typeOptions: 'configurationOptions',
                                            }
                                        },
                                        {
                                            type: 'GroupSettingBase',
                                            data: {
                                                dependencySettings: [
                                                    {
                                                        dependencyType: 'isVisible',
                                                        idParams: 'UPG_ElecOut110v30a',
                                                        isValue: true
                                                    }
                                                ],
                                                isVisible: false,
                                                id: 'UPG_ElecOut110v30a#Group',
                                                typeOptions: 'groupingOptions',
                                                additionalProperties: defaultStyle,
                                                embeddedView: [
                                                    {
                                                        type: 'LineParamSelect',
                                                        data: {
                                                            label: 'Quantity',
                                                            id: 'UPG_ElecOut110v30aQuan',
                                                            typeOptions: 'configurationOptions',
                                                            values: [
                                                                { label: "1", value: '1' },
                                                                { label: "2", value: '2' },
                                                                { label: "3", value: '3' },
                                                                { label: "4", value: '4' },
                                                                { label: "5", value: '5' },
                                                            ],
                                                            additionalProperties: {
                                                                maxWidth: '252px',
                                                                margin: '0'
                                                            }
                                                        },
                                                    },

                                                ]
                                            }
                                        },
                                        {
                                            type: 'SwitchStandardST',
                                            data: {
                                                label: 'Add Wall Switch',
                                                id: 'UPG_ElecSwitch',
                                                typeOptions: 'configurationOptions',
                                            }
                                        },
                                        {
                                            type: 'GroupSettingBase',
                                            data: {
                                                dependencySettings: [
                                                    {
                                                        dependencyType: 'isVisible',
                                                        idParams: 'UPG_ElecSwitch',
                                                        isValue: true
                                                    }
                                                ],
                                                isVisible: false,
                                                id: 'UPG_ElecSwitch#Group',
                                                typeOptions: 'groupingOptions',
                                                additionalProperties: defaultStyle,
                                                embeddedView: [
                                                    {
                                                        type: 'LineParamSelect',
                                                        data: {
                                                            label: 'Quantity',
                                                            id: 'UPG_ElecSwitchQuan',
                                                            typeOptions: 'configurationOptions',
                                                            values: [
                                                                { label: "1", value: '1' },
                                                                { label: "2", value: '2' },
                                                                { label: "3", value: '3' },
                                                                { label: "4", value: '4' },
                                                                { label: "5", value: '5' },
                                                            ],
                                                            additionalProperties: {
                                                                maxWidth: '252px',
                                                                margin: '0'
                                                            }
                                                        },
                                                    },

                                                ]
                                            }
                                        },


                                        {
                                            type: 'SwitchStandardST',
                                            data: {
                                                label: 'Additional 110v 15 amp Outlet',
                                                id: 'UPG_ElecOut110v15a',
                                                typeOptions: 'configurationOptions',
                                            }
                                        },

                                        {
                                            type: 'GroupSettingBase',
                                            data: {
                                                dependencySettings: [
                                                    {
                                                        dependencyType: 'isVisible',
                                                        idParams: 'UPG_ElecOut110v15a',
                                                        isValue: true
                                                    }
                                                ],
                                                isVisible: false,
                                                id: 'UPG_ElecOut110v15a#Group',
                                                typeOptions: 'groupingOptions',
                                                additionalProperties: {
                                                    groupGap: true,
                                                    backgroundColor: '#F4F3F3',
                                                    gap: '12px',
                                                    padding: '6px 19px',
                                                    margin: '0 -16px',
                                                },
                                                embeddedView: [
                                                    {
                                                        type: 'LineParamSelect',
                                                        data: {
                                                            label: 'Quantity',
                                                            id: 'UPG_ElecOut110v15aQuan',
                                                            typeOptions: 'configurationOptions',
                                                            values: [
                                                                { label: "1", value: '1' },
                                                                { label: "2", value: '2' },
                                                                { label: "3", value: '3' },
                                                                { label: "4", value: '4' },
                                                                { label: "5", value: '5' },
                                                            ],
                                                            additionalProperties: {
                                                                maxWidth: '252px',
                                                                margin: '0'
                                                            }
                                                        },
                                                    },

                                                ]
                                            }
                                        },
                                        {
                                            type: 'SwitchStandardST',
                                            data: {
                                                label: 'Add 110v 20 amp Outlet',
                                                id: 'UPG_ElecOut110v20a',
                                                typeOptions: 'configurationOptions',
                                            }
                                        },



                                        {
                                            type: 'GroupSettingBase',
                                            data: {
                                                dependencySettings: [
                                                    {
                                                        dependencyType: 'isVisible',
                                                        idParams: 'UPG_ElecOut110v20a',
                                                        isValue: true
                                                    }
                                                ],
                                                isVisible: false,
                                                id: 'UPG_ElecOut110v20a#Group',
                                                typeOptions: 'groupingOptions',
                                                additionalProperties: {
                                                    groupGap: true,
                                                    backgroundColor: '#F4F3F3',
                                                    gap: '12px',
                                                    padding: '6px 19px',
                                                    margin: '0 -16px',
                                                },
                                                embeddedView: [
                                                    {
                                                        type: 'LineParamSelect',
                                                        data: {
                                                            label: 'Quantity',
                                                            id: 'UPG_ElecOut110v20aQuan',
                                                            typeOptions: 'configurationOptions',
                                                            values: [
                                                                { label: "1", value: '1' },
                                                                { label: "2", value: '2' },
                                                                { label: "3", value: '3' },
                                                                { label: "4", value: '4' },
                                                                { label: "5", value: '5' },
                                                            ],
                                                            additionalProperties: {
                                                                maxWidth: '252px',
                                                                margin: '0'
                                                            }
                                                        },
                                                    },

                                                ]
                                            }
                                        },


                                        {
                                            type: 'SwitchStandardST',
                                            data: {
                                                label: 'Add 220v 30 amp Outlet',
                                                id: 'UPG_ElecOut220v30a',
                                                typeOptions: 'configurationOptions',
                                            }
                                        },
                                        {
                                            type: 'GroupSettingBase',
                                            data: {
                                                dependencySettings: [
                                                    {
                                                        dependencyType: 'isVisible',
                                                        idParams: 'UPG_ElecOut220v30a',
                                                        isValue: true
                                                    }
                                                ],
                                                isVisible: false,
                                                id: 'UPG_ElecOut220v30a#Group',
                                                typeOptions: 'groupingOptions',
                                                additionalProperties: defaultStyle,
                                                embeddedView: [
                                                    {
                                                        type: 'LineParamSelect',
                                                        data: {
                                                            label: 'Quantity',
                                                            id: 'UPG_ElecOut220v30a',
                                                            typeOptions: 'configurationOptions',
                                                            values: [
                                                                { label: "1", value: '1' },
                                                                { label: "2", value: '2' },
                                                                { label: "3", value: '3' },
                                                                { label: "4", value: '4' },
                                                                { label: "5", value: '5' },
                                                            ],
                                                            additionalProperties: {
                                                                maxWidth: '252px',
                                                                margin: '0'
                                                            }
                                                        },
                                                    },

                                                ]
                                            }
                                        },
                                        {
                                            type: 'SwitchStandardST',
                                            data: {
                                                label: 'Add 220v 50 amp Outlet',
                                                id: 'UPG_ElecOut220v50a',
                                                typeOptions: 'configurationOptions',
                                            }
                                        },
                                        {
                                            type: 'GroupSettingBase',
                                            data: {
                                                dependencySettings: [
                                                    {
                                                        dependencyType: 'isVisible',
                                                        idParams: 'UPG_ElecOut220v50a',
                                                        isValue: true
                                                    }
                                                ],
                                                isVisible: false,
                                                id: 'UPG_ElecOut220v50a#Group',
                                                typeOptions: 'groupingOptions',
                                                additionalProperties: defaultStyle,
                                                embeddedView: [
                                                    {
                                                        type: 'LineParamSelect',
                                                        data: {
                                                            label: 'Quantity',
                                                            id: 'UPG_ElecOut220v50aQuan',
                                                            typeOptions: 'configurationOptions',
                                                            values: [
                                                                { label: "1", value: '1' },
                                                                { label: "2", value: '2' },
                                                                { label: "3", value: '3' },
                                                                { label: "4", value: '4' },
                                                                { label: "5", value: '5' },
                                                            ],
                                                            additionalProperties: {
                                                                maxWidth: '252px',
                                                                margin: '0'
                                                            }
                                                        },
                                                    },

                                                ]
                                            }
                                        },


                                        {
                                            type: 'SwitchStandardST',
                                            data: {
                                                label: 'Add Exterior 110v 20 amp Outlet',
                                                id: 'UPG_ElecOutExt',
                                                typeOptions: 'configurationOptions',
                                            }
                                        },
                                        {
                                            type: 'GroupSettingBase',
                                            data: {
                                                dependencySettings: [
                                                    {
                                                        dependencyType: 'isVisible',
                                                        idParams: 'UPG_ElecOutExt',
                                                        isValue: true
                                                    }
                                                ],
                                                isVisible: false,
                                                id: 'UPG_ElecOutExt#Group',
                                                typeOptions: 'groupingOptions',
                                                additionalProperties: defaultStyle,
                                                embeddedView: [
                                                    {
                                                        type: 'LineParamSelect',
                                                        data: {
                                                            label: 'Quantity',
                                                            id: 'UPG_ElecOutExt',
                                                            typeOptions: 'configurationOptions',
                                                            values: [
                                                                { label: "1", value: '1' },
                                                                { label: "2", value: '2' },
                                                                { label: "3", value: '3' },
                                                                { label: "4", value: '4' },
                                                                { label: "5", value: '5' },
                                                            ],
                                                            additionalProperties: {
                                                                maxWidth: '252px',
                                                                margin: '0'
                                                            }
                                                        },
                                                    },

                                                ]
                                            }
                                        },

                                        {
                                            type: 'SwitchStandardST',
                                            data: {
                                                label: 'Add 48" LED Light',
                                                id: 'UPG_ElecLigFlor',
                                                typeOptions: 'configurationOptions',
                                            }
                                        },
                                        {
                                            type: 'GroupSettingBase',
                                            data: {
                                                dependencySettings: [
                                                    {
                                                        dependencyType: 'isVisible',
                                                        idParams: 'UPG_ElecLigFlor',
                                                        isValue: true
                                                    }
                                                ],
                                                isVisible: false,
                                                id: 'UPG_ElecLigFlor#Group',
                                                typeOptions: 'groupingOptions',
                                                additionalProperties: defaultStyle,
                                                embeddedView: [
                                                    {
                                                        type: 'LineParamSelect',
                                                        data: {
                                                            label: 'Quantity',
                                                            id: 'UPG_ElecLigFlorQuan',
                                                            typeOptions: 'configurationOptions',
                                                            values: [
                                                                { label: "1", value: '1' },
                                                                { label: "2", value: '2' },
                                                                { label: "3", value: '3' },
                                                                { label: "4", value: '4' },
                                                                { label: "5", value: '5' },
                                                            ],
                                                            additionalProperties: {
                                                                maxWidth: '252px',
                                                                margin: '0'
                                                            }
                                                        },
                                                    },

                                                ]
                                            }
                                        },
                                        {
                                            type: 'SwitchStandardST',
                                            data: {
                                                label: 'Add Incandescent Light',
                                                id: 'UPG_ElecLig',
                                                typeOptions: 'configurationOptions',
                                            }
                                        },
                                        {
                                            type: 'GroupSettingBase',
                                            data: {
                                                dependencySettings: [
                                                    {
                                                        dependencyType: 'isVisible',
                                                        idParams: 'UPG_ElecLig',
                                                        isValue: true
                                                    }
                                                ],
                                                isVisible: false,
                                                id: 'UPG_ElecLig#Group',
                                                typeOptions: 'groupingOptions',
                                                additionalProperties: defaultStyle,
                                                embeddedView: [
                                                    {
                                                        type: 'LineParamSelect',
                                                        data: {
                                                            label: 'Quantity',
                                                            id: 'UPG_ElecLigQuan',
                                                            typeOptions: 'configurationOptions',
                                                            values: [
                                                                { label: "1", value: '1' },
                                                                { label: "2", value: '2' },
                                                                { label: "3", value: '3' },
                                                                { label: "4", value: '4' },
                                                                { label: "5", value: '5' },
                                                            ],
                                                            additionalProperties: {
                                                                maxWidth: '252px',
                                                                margin: '0'
                                                            }
                                                        },
                                                    },

                                                ]
                                            }
                                        },

                                        {
                                            type: 'SwitchStandardST',
                                            data: {
                                                label: 'Add Porch Light w/ Switch',
                                                id: 'UPG_ElecLigPorchPkg',
                                                typeOptions: 'configurationOptions',
                                            }
                                        },
                                        {
                                            type: 'GroupSettingBase',
                                            data: {
                                                dependencySettings: [
                                                    {
                                                        dependencyType: 'isVisible',
                                                        idParams: 'UPG_ElecLigPorchPkg',
                                                        isValue: true
                                                    }
                                                ],
                                                isVisible: false,
                                                id: 'UPG_ElecLigPorchPkg#Group',
                                                typeOptions: 'groupingOptions',
                                                additionalProperties: defaultStyle,
                                                embeddedView: [
                                                    {
                                                        type: 'LineParamSelect',
                                                        data: {
                                                            label: 'Quantity',
                                                            id: 'UPG_ElecLigPorchPkgQuan',
                                                            typeOptions: 'configurationOptions',
                                                            values: [
                                                                { label: "1", value: '1' },
                                                                { label: "2", value: '2' },
                                                                { label: "3", value: '3' },
                                                                { label: "4", value: '4' },
                                                                { label: "5", value: '5' },
                                                            ],
                                                            additionalProperties: {
                                                                maxWidth: '252px',
                                                                margin: '0'
                                                            }
                                                        },
                                                    },

                                                ]
                                            }
                                        },

                                        {
                                            type: 'SwitchStandardST',
                                            data: {
                                                label: 'Add Dual Flood Light w/ Switch',
                                                id: 'UPG_ElecLigFloodPkg',
                                                typeOptions: 'configurationOptions',
                                            }
                                        },

                                        {
                                            type: 'GroupSettingBase',
                                            data: {
                                                dependencySettings: [
                                                    {
                                                        dependencyType: 'isVisible',
                                                        idParams: 'UPG_ElecLigFloodPkg',
                                                        isValue: true
                                                    }
                                                ],
                                                isVisible: false,
                                                id: 'UPG_ElecLigPorchPkg#Group',
                                                typeOptions: 'groupingOptions',
                                                additionalProperties: defaultStyle,
                                                embeddedView: [
                                                    {
                                                        type: 'LineParamSelect',
                                                        data: {
                                                            label: 'Quantity',
                                                            id: 'UPG_ElecLigFloodPkgQuan',
                                                            typeOptions: 'configurationOptions',
                                                            values: [
                                                                { label: "1", value: '1' },
                                                                { label: "2", value: '2' },
                                                                { label: "3", value: '3' },
                                                                { label: "4", value: '4' },
                                                                { label: "5", value: '5' },
                                                            ],
                                                            additionalProperties: {
                                                                maxWidth: '252px',
                                                                margin: '0'
                                                            }
                                                        },
                                                    },

                                                ]
                                            }
                                        },

                                        {
                                            type: 'SwitchStandardST',
                                            data: {
                                                label: "Electrical Pigtail from Breaker box, 3' extension",
                                                id: 'ElecPigTail',
                                                typeOptions: 'configurationOptions',
                                            }
                                        },
                                        {
                                            type: 'SwitchStandardST',
                                            data: {
                                                label: "Electrical Surface mount LED light",
                                                id: 'ElecLigCanLED',
                                                typeOptions: 'configurationOptions',
                                            }
                                        },
                                        {
                                            type: 'GroupSettingBase',
                                            data: {
                                                dependencySettings: [
                                                    {
                                                        dependencyType: 'isVisible',
                                                        idParams: 'ElecLigCanLED',
                                                        isValue: true
                                                    }
                                                ],
                                                isVisible: false,
                                                id: 'ElecLigCanLED#Group',
                                                typeOptions: 'groupingOptions',
                                                additionalProperties: defaultStyle,
                                                embeddedView: [
                                                    {
                                                        type: 'LineParamSelect',
                                                        data: {
                                                            label: 'Quantity',
                                                            id: 'ElecLigCanLED_Qty',
                                                            typeOptions: 'configurationOptions',
                                                            values: [
                                                                { label: "1", value: '1' },
                                                                { label: "2", value: '2' },
                                                                { label: "3", value: '3' },
                                                                { label: "4", value: '4' },
                                                                { label: "5", value: '5' },
                                                            ],
                                                            additionalProperties: {
                                                                maxWidth: '252px',
                                                                margin: '0'
                                                            }
                                                        },
                                                    },

                                                ]
                                            }
                                        },

                                        {
                                            type: 'SwitchStandardST',
                                            data: {
                                                label: 'Upgrade Panel to 200 amp',
                                                id: 'UPG_Elec200aPnl',
                                                typeOptions: 'configurationOptions',
                                            }
                                        },

                                    ]
                                }
                            },











                        ]
                    }
                },






















                {
                    type: 'SettingOpening',
                    data: {
                        label: 'Ramp Options',
                        id: 'OptionsSideGroup_SideB123311',
                        typeOptions: 'configurationOptions',
                        additionalProperties: {
                            groupGap: true,
                        },
                        embeddedView: [

                            {
                                type: 'SwitchStandardST',
                                data: {
                                    label: '5x5 Wood Ramp For Shed Doo',
                                    id: 'UPG_RampWood',
                                    typeOptions: 'configurationOptions',
                                }
                            },
                            {
                                type: 'GroupSettingBase',
                                data: {
                                    dependencySettings: [
                                        {
                                            dependencyType: 'isVisible',
                                            idParams: 'UPG_RampWood',
                                            isValue: true
                                        }
                                    ],
                                    isVisible: false,
                                    id: 'UPG_RampWood#Group',
                                    typeOptions: 'groupingOptions',
                                    additionalProperties: defaultStyle,
                                    embeddedView: [
                                        {
                                            type: 'LineParamSelect',
                                            data: {
                                                label: 'Quantity',
                                                id: 'UPG_RampWoodQuan',
                                                typeOptions: 'configurationOptions',
                                                values: [
                                                    { label: "1", value: '1' },
                                                    { label: "2", value: '2' },
                                                    { label: "3", value: '3' },
                                                    { label: "4", value: '4' },
                                                    { label: "5", value: '5' },
                                                ],
                                                additionalProperties: {
                                                    maxWidth: '252px',
                                                    margin: '0'
                                                }
                                            },
                                        },

                                    ]
                                }
                            },
                            {
                                type: 'SwitchStandardST',
                                data: {
                                    label: '8x9 Pressure Treated Garage Ramp',
                                    id: 'UPG_RampGarage89',
                                    typeOptions: 'configurationOptions',
                                }
                            },
                            {
                                type: 'GroupSettingBase',
                                data: {
                                    dependencySettings: [
                                        {
                                            dependencyType: 'isVisible',
                                            idParams: 'UPG_RampGarage89',
                                            isValue: true
                                        }
                                    ],
                                    isVisible: false,
                                    id: 'UPG_RampGarage89#Group',
                                    typeOptions: 'groupingOptions',
                                    additionalProperties: defaultStyle,
                                    embeddedView: [
                                        {
                                            type: 'LineParamSelect',
                                            data: {
                                                label: 'Quantity',
                                                id: 'UPG_RampGarage89Quan',
                                                typeOptions: 'configurationOptions',
                                                values: [
                                                    { label: "1", value: '1' },
                                                    { label: "2", value: '2' },
                                                    { label: "3", value: '3' },
                                                    { label: "4", value: '4' },
                                                    { label: "5", value: '5' },
                                                ],
                                                additionalProperties: {
                                                    maxWidth: '252px',
                                                    margin: '0'
                                                }
                                            },
                                        },

                                    ]
                                }
                            },
                            {
                                type: 'SwitchStandardST',
                                data: {
                                    label: '7x7 Pressure Treated Garage Ram',
                                    id: 'UPG_RampGarage77',
                                    typeOptions: 'configurationOptions',
                                }
                            },
                            {
                                type: 'GroupSettingBase',
                                data: {
                                    dependencySettings: [
                                        {
                                            dependencyType: 'isVisible',
                                            idParams: 'UPG_RampGarage77',
                                            isValue: true
                                        }
                                    ],
                                    isVisible: false,
                                    id: 'UPG_RampGarage77#Group',
                                    typeOptions: 'groupingOptions',
                                    additionalProperties: defaultStyle,
                                    embeddedView: [
                                        {
                                            type: 'LineParamSelect',
                                            data: {
                                                label: 'Quantity',
                                                id: 'UPG_RampGarage77Quan',
                                                typeOptions: 'configurationOptions',
                                                values: [
                                                    { label: "1", value: '1' },
                                                    { label: "2", value: '2' },
                                                    { label: "3", value: '3' },
                                                    { label: "4", value: '4' },
                                                    { label: "5", value: '5' },
                                                ],
                                                additionalProperties: {
                                                    maxWidth: '252px',
                                                    margin: '0'
                                                }
                                            },
                                        },

                                    ]
                                }
                            },

                        ]
                    }
                },
                {
                    type: 'SettingOpening',
                    data: {
                        label: 'Delivery & Setup Options',
                        id: 'OptionsSideGroup_SideB1244',
                        typeOptions: 'configurationOptions',
                        additionalProperties: {
                            groupGap: true,
                        },
                        embeddedView: [

                            {
                                type: 'SwitchStandardST',
                                data: {
                                    label: 'Permit Service Fee',
                                    id: 'UPG_PermitFee',
                                    typeOptions: 'configurationOptions',
                                }
                            },
                            {
                                type: 'SwitchStandardST',
                                data: {
                                    label: 'Additional Labor per 4" Block Layer',
                                    id: 'UPG_BlockLayer',
                                    typeOptions: 'configurationOptions',
                                }
                            },
                            {
                                type: 'GroupSettingBase',
                                data: {
                                    dependencySettings: [
                                        {
                                            dependencyType: 'isVisible',
                                            idParams: 'UPG_BlockLayer',
                                            isValue: true
                                        }
                                    ],
                                    isVisible: false,
                                    id: 'UPG_BlockLayer#Group',
                                    typeOptions: 'groupingOptions',
                                    additionalProperties: defaultStyle,
                                    embeddedView: [
                                        {
                                            type: 'LineParamSelect',
                                            data: {
                                                label: 'Quantity',
                                                id: 'UPG_BlockLayerQuan',
                                                typeOptions: 'configurationOptions',
                                                values: [
                                                    { label: "1", value: '1' },
                                                    { label: "2", value: '2' },
                                                    { label: "3", value: '3' },
                                                    { label: "4", value: '4' },
                                                    { label: "5", value: '5' },
                                                ],
                                                additionalProperties: {
                                                    maxWidth: '252px',
                                                    margin: '0'
                                                }
                                            },
                                        },

                                    ]
                                }
                            },
                            {
                                type: 'SwitchStandardST',
                                data: {
                                    label: 'Wood Fence Removal (2 panels/1Post)',
                                    id: 'UPG_FenceRemWood',
                                    typeOptions: 'configurationOptions',
                                }
                            },
                            {
                                type: 'SwitchStandardST',
                                data: {
                                    label: 'Chainlink Fence Removal (No reinstall)',
                                    id: 'UPG_FenceRemChain',
                                    typeOptions: 'configurationOptions',
                                }
                            },
                            {
                                type: 'SwitchStandardST',
                                data: {
                                    label: 'Tie Down Anchor Package (4 anchors)',
                                    id: 'UPG_AnchorPkg',
                                    typeOptions: 'configurationOptions',
                                }
                            },
                            {
                                type: 'SwitchStandardST',
                                data: {
                                    label: 'Wet stamp Engineered Plans',
                                    id: 'UPG_EngineeringFee',
                                    typeOptions: 'configurationOptions',
                                }
                            },
                            {
                                type: 'SwitchStandardST',
                                data: {
                                    label: 'Tie Down Anchor (ea) and its Quantity',
                                    id: 'UPG_Anchor',
                                    typeOptions: 'configurationOptions',
                                }
                            },
                            {
                                type: 'GroupSettingBase',
                                data: {
                                    dependencySettings: [
                                        { dependencyType: 'isVisible', idParams: 'UPG_Anchor', isValue: true }
                                    ],
                                    isVisible: false,
                                    id: 'UPG_AnchorQuan#Group',
                                    typeOptions: 'groupingOptions',
                                    additionalProperties: defaultStyle,
                                    embeddedView: [
                                        {
                                            type: 'LineParamSelect',
                                            data: {
                                                label: 'Quantity',
                                                id: 'UPG_AnchorQuan',
                                                typeOptions: 'configurationOptions',
                                                values: [
                                                    { label: "1", value: '1' },
                                                    { label: "2", value: '2' },
                                                    { label: "3", value: '3' },
                                                    { label: "4", value: '4' },
                                                    { label: "5", value: '5' },
                                                ],
                                                additionalProperties: {
                                                    maxWidth: '252px',
                                                    margin: '0'
                                                }
                                            },
                                        },

                                    ]
                                }
                            },
                            {
                                type: 'SwitchStandardST',
                                data: {
                                    label: 'Skirting Around Perimeter of Building',
                                    id: 'UPG_Skirting',
                                    typeOptions: 'configurationOptions',
                                }
                            },

                        ]
                    }
                },
                {
                    type: 'SettingOpening',
                    data: {
                        label: 'Other Options',
                        id: 'OptionsSideGroup_SideB1255',
                        typeOptions: 'configurationOptions',
                        additionalProperties: {
                            groupGap: true,
                        },
                        embeddedView: [

                            {
                                type: 'SwitchStandardST',
                                data: {
                                    label: 'Change Order Fee',
                                    id: 'UPG_ChangeOrder',
                                    typeOptions: 'configurationOptions',
                                }
                            },

                        ]
                    }
                }


            ]
        }
    }

]
export let settingsC: Array<IComponent> = [
    {
        type: 'GroupSetting',
        data: {
            id: 'BaseOption__PorchOptions',
            typeOptions: 'groupingOptions',
            embeddedView: [
                {
                    type: 'LineParamRadio',
                    data: {
                        id: 'RoofMaterialType',
                        label: 'Roof Material',
                        typeOptions: 'configurationOptions',
                        values: [
                            { label: 'Shingle', value: 'Shingle' },
                            { label: 'Metal', value: 'Metal' },
                        ],
                        additionalProperties: {
                            maxWidth: '308px'
                        },
                    }
                },
                {
                    type: 'GroupSettingBase',
                    data: {

                        isVisible: false,
                        id: 'BaseOption__Group_1',
                        typeOptions: 'groupingOptions',
                        dependencySettings: [
                            {
                                dependencyType: 'isVisible',
                                idParams: 'RoofMaterialType',
                                isValue: 'Metal'
                            }
                        ],
                        embeddedView: [
                            {
                                type: 'LineParamGT',
                                data: {
                                    label: 'Metal Profile ',
                                    id: 'Metal Profile',
                                    typeOptions: 'groupingOptions',
                                    isRequired: false,
                                    embeddedView: [
                                        {
                                            type: 'RadioSwitcherST',
                                            data: {
                                                id: 'RoofMaterialType',
                                                typeOptions: 'configurationOptions',
                                                values: [
                                                    {
                                                        id: 'Upscale',
                                                        img: Upscale,
                                                        name: 'Upscale',

                                                    },
                                                    {
                                                        id: 'Classic',
                                                        img: Classic,
                                                        name: 'Classic',
                                                    },
                                                ]
                                            }
                                        },
                                    ]
                                }
                            },
                        ]
                    }
                },

                {
                    type: 'ColorSelectionSectionST',
                    data: {
                        id: 'RoofColor',
                        label: 'Roof Color',
                        typeOptions: 'configurationOptions',
                        values: [
                            {
                                id: 'Charcoal Grey1',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey2',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey3',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey4',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey5',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey6',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey7',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },

                        ],
                        embeddedView: [
                            {
                                type: 'LineParamInput',
                                data: {
                                    id: 'CustomRoofColor',
                                    typeOptions: 'configurationOptions',
                                    label: 'Custom Color Code',
                                    typeParam: 'LineParamInput',
                                    additionalProperties: {
                                        maxWidth: '308px'
                                    }
                                }
                            },
                        ]
                    }
                },
                {
                    type: 'ColorSelectionSectionST',
                    data: {
                        id: 'StainColor',
                        label: 'Stain Color',
                        typeOptions: 'configurationOptions',
                        values: [
                            {
                                id: 'Charcoal Grey1',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey2',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey3',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey4',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey5',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey6',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey7',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },

                        ],

                    }
                },
                {
                    type: 'ColorSelectionSectionST',
                    data: {
                        id: 'CornerTrimColor',
                        label: 'Corner Trim Color',
                        typeOptions: 'configurationOptions',
                        values: [
                            {
                                id: 'Charcoal Grey1',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey2',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey3',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey4',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey5',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey6',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey7',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },

                        ],
                        embeddedView: [
                            {
                                type: 'LineParamInput',
                                data: {
                                    id: 'CustomCornerTrimColor',
                                    typeOptions: 'configurationOptions',
                                    label: 'Custom Color Code',
                                    typeParam: 'LineParamInput',
                                    additionalProperties: {
                                        maxWidth: '308px'
                                    }
                                }
                            },
                        ]
                    }
                },
                {
                    type: 'ColorSelectionSectionST',
                    data: {
                        id: 'ShedDoorPanelColor',
                        label: 'Shed Door Panel Color',
                        typeOptions: 'configurationOptions',
                        values: [
                            {
                                id: 'Charcoal Grey1',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey2',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey3',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey4',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey5',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey6',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey7',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },

                        ],
                        embeddedView: [
                            {
                                type: 'LineParamInput',
                                data: {
                                    id: 'CustomShedDoorPanelColor',
                                    typeOptions: 'configurationOptions',
                                    label: 'Custom Color Code',
                                    typeParam: 'LineParamInput',
                                    additionalProperties: {
                                        maxWidth: '308px'
                                    }
                                }
                            },
                            {
                                type: 'SwitchStandardST',
                                data: {
                                    label: 'Match Door Trim To Panel',
                                    id: 'ColorsMatchDoorTrimToPanel',
                                    typeOptions: 'configurationOptions',
                                }
                            },
                        ]
                    }
                },
                {
                    type: 'ColorSelectionSectionST',
                    data: {
                        id: 'SidingColor',
                        label: 'Siding Color',
                        typeOptions: 'configurationOptions',
                        values: [
                            {
                                id: 'Charcoal Grey1',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey2',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey3',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey4',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey5',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey6',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey7',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },

                        ],
                        embeddedView: [
                            {
                                type: 'LineParamInput',
                                data: {
                                    id: 'CustomSidingColor',
                                    typeOptions: 'configurationOptions',
                                    label: 'Custom Color Code',
                                    typeParam: 'LineParamInput',
                                    additionalProperties: {
                                        maxWidth: '308px'
                                    }
                                }
                            },
                        ]
                    }
                },
                {
                    type: 'ColorSelectionSectionST',
                    data: {
                        id: 'Trim Color',
                        label: 'Trim Color',
                        typeOptions: 'configurationOptions',
                        values: [
                            {
                                id: 'Charcoal Grey1',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey2',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey3',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey4',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey5',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey6',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey7',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },

                        ],
                        embeddedView: [
                            {
                                type: 'LineParamInput',
                                data: {
                                    id: 'CustomTrimColor',
                                    typeOptions: 'configurationOptions',
                                    label: 'Custom Color Code',
                                    typeParam: 'LineParamInput',
                                    additionalProperties: {
                                        maxWidth: '308px'
                                    }
                                }
                            },
                        ]
                    }
                },
                {
                    type: 'ColorSelectionSectionST',
                    data: {
                        id: 'ShuttersFlowerBoxesColor',
                        label: 'Shutters/Flower Boxes Color',
                        typeOptions: 'configurationOptions',
                        values: [
                            {
                                id: 'Charcoal Grey1',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey2',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey3',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey4',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey5',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey6',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },
                            {
                                id: 'Charcoal Grey7',
                                name: 'Charcoal Grey',
                                color: '#EDEAE2',

                            },

                        ],
                        embeddedView: [
                            {
                                type: 'LineParamInput',
                                data: {
                                    id: 'CustomShuttersFlowerBoxesColor',
                                    typeOptions: 'configurationOptions',
                                    label: 'Custom Color Code',
                                    typeParam: 'LineParamInput',
                                    additionalProperties: {
                                        maxWidth: '308px'
                                    }
                                }
                            },
                        ]
                    }
                },

            ]
        }
    }



]

export let settingUI: settingConfigT[] = [
    {
        key: 'CustomerInfo',
        name: 'Customer info',
        setting: settingsCI
    },
    {
        key: 'Product',
        name: 'Product',
        setting: settingsP
    },
    {
        key: 'BaseOptions',
        name: 'Base Option',
        setting: settingsBaseOption
    },
    {
        key: 'Sides',
        name: 'Sides',
        setting: settingsS
    },
    {
        key: 'Upgrades',
        name: 'Upgrades',
        setting: settingsU
    },
    {
        key: 'Colors',
        name: 'Colors',
        setting: settingsC
    }
]











































